import { render, staticRenderFns } from "./RegisterCompany.vue?vue&type=template&id=4663da06&scoped=true&lang=pug&"
import script from "./RegisterCompany.vue?vue&type=script&lang=ts&"
export * from "./RegisterCompany.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterCompany.vue?vue&type=style&index=0&id=4663da06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4663da06",
  null
  
)

export default component.exports